import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import CrisisZonePage from '@/pages/CrisisZonePage';
import { BlackoutPaywallSplash } from '@/components/blackout/BlackoutPaywallSplash';

/**
 * Route gate for /blackout.
 *
 *  - Logged-out user      → marketing splash (their CTA prompts login first).
 *  - Locked logged-in user → marketing splash + Stripe checkout CTA (£6).
 *  - Unlocked user        → full <CrisisZonePage /> as before.
 *
 * The unlock state lives at user.blackout_unlocked_at and is auto-refreshed
 * after the Stripe success page (BlackoutUnlockedPage calls refreshUser).
 */
export const BlackoutGate = () => {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <BlackoutPaywallSplash
        onUnlocked={() => navigate('/login?next=/blackout')}
      />
    );
  }

  // Admins bypass the paywall entirely — they need access to support users
  // and verify the feature works without paying.
  const isAdmin = user.role === 'admin' || user.is_admin === true;
  if (isAdmin || user.blackout_unlocked_at) {
    return <CrisisZonePage />;
  }

  return <BlackoutPaywallSplash onUnlocked={() => refreshUser?.()} />;
};

export default BlackoutGate;
